import { createTableFilterSlice } from 'common/stores/redux/TableFilter';

const adminClientFilterSlice = createTableFilterSlice('adminClientFilter');

export const {
    add,
    addAdvanced,
    remove,
    removeAll,
    setDefaultAdvancedFilters,
} = adminClientFilterSlice.actions;

export default adminClientFilterSlice.reducer;
